import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../../GlobalStore';

const RemoteDelivery: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    globalStore.selectedMenuKey = 'daily-delivery';
    globalStore.forceWhiteHeader = true;

    return () => {
      globalStore.forceWhiteHeader = false;
    };
  }, []);

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const secondRef = useRef<HTMLDivElement | null>(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const scrollToSecond = () => {
    secondRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  type Level = 'good' | 'medium' | 'bad';
  const pillStyle: Record<Level, React.CSSProperties> = {
    good: { background: ' #ecfdf5', color: 'rgb(6, 167, 17)', border: '1px solid #a7f3d0' },
    medium: { background: ' #fff7ed', color: 'rgb(236, 117, 12)', border: '1px solid #fed7aa' },
    bad: { background: ' #fef2f2', color: ' #b91c1c', border: '1px solid #fecaca' },
  };

  const metrics = [
    {
      label: '办公场地费用',
      values: ['由企业承担', '由企业承担', '无需场所，零支出'],
      levels: ['bad', 'bad', 'good'] as const,
    },
    {
      label: '基本薪资费用',
      values: ['总支出夸张', '虽无杂项，也并不低', '同质量价格非常低'],
      levels: ['bad', 'medium', 'good'] as const,
    },
    {
      label: '裁员赔付费用',
      values: ['N+1，较为夸张', '一般无需赔付', '双方自由，零解约费用'],
      levels: ['bad', 'good', 'good'] as const,
    },
    {
      label: '人事薪资费用',
      values: ['数十万每年', '无额外人事费用', '无额外人事费用'],
      levels: ['bad', 'good', 'good'] as const,
    },
    {
      label: '电脑耗材费用',
      values: ['由企业承担', '由企业承担', '由卖家自己承担'],
      levels: ['bad', 'bad', 'good'] as const,
    },
  ];

  const plans = [
    { title: '传统招聘', accent: 'linear-gradient(135deg, #fde68a 0%, #f59e0b 100%)', index: 0 },
    { title: '传统外包', accent: 'linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)', index: 1 },
    { title: '圆领按月承揽', accent: 'linear-gradient(135deg, #2DD4BF 0%, #60A5FA 100%)', index: 2 },
  ] as const;

  return (
    <div style={{ backgroundColor: '#fff', fontFamily: 'Helvetica, Arial, sans-serif', color: '#333' }}>

      {/* ✅ 首屏：宣传视频（不超出100vh） */}
      <section style={{ position: 'relative', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 24px' }}>
        <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ position: 'relative', width: '100%', maxWidth: '900px', margin: '0 auto', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(0,0,0,0.15)' }}>
            <video
              ref={videoRef}
              width="100%"
              height={480}
              src="https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/7b/7b8fba76efd79b144994bd2f2c13eab3dc22b14a693dc382f54d0cc2e169f10d.mp4"
              controls
              playsInline
              preload="metadata"
              style={{ display: 'block' }}
              onPlay={() => setShowOverlay(false)}
              onPause={() => setShowOverlay(true)}
            />
            {showOverlay && (
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'auto' }}>
                <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)' }} />
                <div style={{ position: 'relative', textAlign: 'center', padding: '24px' }}>
                  <h1 style={{ margin: 0, fontSize: '42px', fontWeight: 800, color: '#ffffff', textShadow: '0 4px 8px rgba(0,0,0,0.6)' }}>日交付可视化</h1>
                  <p style={{ margin: '14px 0 18px', fontSize: '18px', lineHeight: 1.6, color: '#f3f4f6', textShadow: '0 2px 4px rgba(0,0,0,0.6)' }}>
                    让管理层与团队每天都能清晰看到交付成果
                  </p>
                  <button
                    onClick={() => {
                      if (videoRef.current) {
                        videoRef.current.play().catch(() => {});
                      }
                    }}
                    style={{
                      padding: '12px 28px',
                      borderRadius: '6px',
                      border: '0',
                      background: 'linear-gradient(135deg, #2DD4BF 0%, #60A5FA 100%)',
                      color: '#0b1220',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 700,
                      boxShadow: '0 4px 12px rgba(45, 212, 191, 0.4), 0 2px 4px rgba(96, 165, 250, 0.3)'
                    }}
                  >
                    立即播放
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 下滑提示 */}
        <div
          onClick={scrollToSecond}
          title="向下滚动"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "24px",
            width: "28px",
            height: "44px",
            borderRadius: "20px",
            border: "2px solid rgba(0,0,0,0.3)",
            cursor: "pointer",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            paddingTop: "6px",
            opacity: 0.7,
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            style={{
              width: "4px",
              height: "8px",
              borderRadius: "4px",
              background: "rgba(0,0,0,0.6)",
              animation: "scrollDot 1.6s ease-in-out infinite",
            }}
          />
          <style>
            {`
              @keyframes scrollDot {
                0% { transform: translateY(0); opacity: 1; }
                70% { transform: translateY(16px); opacity: 0; }
                100% { transform: translateY(0); opacity: 0; }
              }
            `}
          </style>
        </div>
      </section>

      {/* ✅ 第二屏：对比卡片（更有视觉冲击） */}
      <section ref={secondRef} style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9fafb', padding: '80px 24px' }}>
        <div style={{ width: '100%', maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: '28px', marginBottom: '12px' }}>上圆领，找会可视化交付的人才！</h2>
            <p style={{ fontSize: '16px', color: '#5b6472', marginBottom: '26px' }}>你所需要做的就是接受远程；而远程的可靠性由日交付可视化来保障。</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
            {plans.map((plan) => (
              <div key={plan.title} style={{ border: '1px solid #eef0f3', borderRadius: '16px', background: '#fff', padding: '24px', boxShadow: '0 8px 24px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                  <div style={{ fontSize: '18px', fontWeight: 700 }}>{plan.title}</div>
                  <div style={{ height: '8px', width: '64px', borderRadius: '999px', background: plan.accent }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {metrics.map((m, idx) => {
                    const level = m.levels[plan.index];
                    return (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', padding: '10px 12px', border: '1px solid #eef0f3', borderRadius: '10px', background: '#fafafa' }}>
                        <div style={{ fontSize: '14px', color: '#5b6472' }}>{m.label}</div>
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 10px', borderRadius: '999px', fontSize: '13px', fontWeight: 600, ...(pillStyle as any)[level as Level] }}>
                          <span>{m.values[plan.index]}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ 第三屏：培训邀请 */}
      <section style={{ height: '100vh', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 24px', background: '#0b1220' }}>
        {/* 背景渐变与光斑 */}
        <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', width: '1200px', height: '600px', top: '-120px', left: '-200px', background: 'radial-gradient(600px 300px at 50% 50%, rgba(56,189,248,0.18), transparent)' }} />
          <div style={{ position: 'absolute', width: '1200px', height: '600px', bottom: '-180px', right: '-240px', background: 'radial-gradient(600px 300px at 50% 50%, rgba(253,224,71,0.16), transparent)' }} />
        </div>
        <div style={{ position: 'relative', width: '100%', maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1.4fr 1fr',
            gap: '32px',
            padding: '40px',
            borderRadius: '20px',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 80px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.08)'
          }}>
            {/* 左：文案与按钮 */}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '18px' }}>
              <div style={{
                fontSize: '30px',
                fontWeight: 800,
                lineHeight: 1.2,
                background: 'linear-gradient(90deg, #fde68a, #f59e0b, #60a5fa 80%)',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                textShadow: '0 6px 18px rgba(0,0,0,0.4)'
              }}>免费远程培训 · 150%人效提升的秘密</div>
              <div style={{ color: '#cbd5e1', fontSize: '16px', lineHeight: 1.9 }}>
                圆领平台讲师将为您的企业提供一次免费的线上讲座（到场的线下培训 5000 元/次可选），系统讲解如何使用“日交付可视化”打造结果导向的远程团队，
                助你实现 150%～300% 的人效提升与更轻松的管理协作。这是一种全新的工作范式，其可操作性、可行性均非常高，任何老板听完基本上就能有自己的判断。
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#e2e8f0' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '999px', background: '#10b981', boxShadow: '0 0 12px rgba(16,185,129,0.8)' }} />
                    到底是什么是可视化交付
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#e2e8f0' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '999px', background: '#60a5fa', boxShadow: '0 0 12px rgba(96,165,250,0.8)' }} />
                    传统交付方法存在的弊病
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#e2e8f0' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '999px', background: '#f59e0b', boxShadow: '0 0 12px rgba(245,158,11,0.8)' }} />
                     如何进行日交付可视化
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#e2e8f0' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '999px', background: '#a78bfa', boxShadow: '0 0 12px rgba(167,139,250,0.8)' }} />
                     老板听了就能明白的硬道理
                  </div>
              </div> 
            </div>

            {/* 右：二维码高级卡片 */}
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{
                position: 'relative',
                padding: '22px',
                borderRadius: '16px',
                background: 'linear-gradient(180deg, rgba(17,24,39,0.9), rgba(11,18,32,0.9))',
                border: '1px solid rgba(253,224,71,0.25)',
                boxShadow: '0 20px 50px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(255,255,255,0.06)'
              }}>
                <div style={{ position: 'absolute', inset: -2, borderRadius: '18px', background: 'linear-gradient(135deg, rgba(253,224,71,0.25), rgba(96,165,250,0.25))', filter: 'blur(14px)', zIndex: -1 }} />
                {globalStore.csContact?.wechatImageUrl ? (
                  <img 
                    src={globalStore.csContact.wechatImageUrl} 
                    alt="培训邀约二维码" 
                    style={{ display: 'block', width: '220px', height: '220px', borderRadius: '10px', background: '#0f172a', objectFit: 'contain' }} 
                  />
                ) : null}
                <div style={{ textAlign: 'center', marginTop: '14px', color: '#f8fafc', fontWeight: 700 }}>微信扫码 · 预约培训</div>
                <div style={{ textAlign: 'center', marginTop: '6px', color: '#94a3b8', fontSize: '12px' }}>线上免费 / 线下 5000 元/次</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
});

export default RemoteDelivery;